import { Injectable, signal } from '@angular/core';
import type { TestMeasureId } from '../widgets/statistics/measures/test-measures/test-measures.model';
import type { SignificanceLevel, TailType } from '../widgets/statistics/tests/test-runner/test-runner.model';
import type { StatTestType } from './data-generator/test-generator/test-library-datasets.model';

@Injectable()
export class TestStore {
  readonly activeTestType = signal<StatTestType>('one-sample-t');
  readonly alpha = signal<SignificanceLevel>(0.05);
  readonly tailType = signal<TailType>('two');
  readonly nullMean = signal<number>(0);
  readonly highlightedMeasure = signal<TestMeasureId | null>(null);

  setTestType(type: StatTestType): void {
    this.activeTestType.set(type);
  }

  setAlpha(alpha: SignificanceLevel): void {
    this.alpha.set(alpha);
  }

  setTailType(tail: TailType): void {
    this.tailType.set(tail);
  }

  setNullMean(mu0: number): void {
    this.nullMean.set(mu0);
  }

  setHighlightedMeasure(measure: TestMeasureId | null): void {
    this.highlightedMeasure.set(measure);
  }
}
